<header class="nina-navbar">
    <!-- =========================================================
       1. BARRA SUPERIOR
       ========================================================= -->
    <button class="nina-navbar__branch-cta" type="button" routerLink="/branches">
        Encuentra tu sucursal más cercana aquí
    </button>
    <!-- =========================================================
       2. BARRA PRINCIPAL
       ========================================================= -->
    <div class="nina-navbar__main">
        <!-- Logo -->
        <a class="nina-navbar__logo" routerLink="/home" aria-label="Nina Pastelería">
            <img src="assets/logos-nina/nina-hd-black.png" alt="Nina Pastelería">
        </a>
        <!-- Buscador -->
        <div class="nina-navbar__search">
            <div class="nina-search">
                <span class="nina-search__icon">
                    <img class="nina-search__icon-tinta" src="assets/iconos-nina-png/tinta/search.png" alt="">
                    <img class="nina-search__icon-coral" src="assets/iconos-nina-png/coral/search.png" alt="">
                </span>
                <input type="text" placeholder="Buscar por..." [(ngModel)]="textoBusqueda"
                    (keyup.enter)="busqueda($event)" (keyup)="onKeyUp($event)">
            </div>
        </div>
        <!-- Mi cuenta -->
        <button class="nina-navbar__account" type="button" (click)="goToAccount()">
            <span class="nina-navbar__icon nina-navbar__icon--user">
                <img class="nina-navbar__icon-tinta" src="assets/iconos-nina-png/tinta/user.png" alt="">
                <img class="nina-navbar__icon-coral" src="assets/iconos-nina-png/coral/user.png" alt="">
            </span>
            <span>
                {{ tokenSSLoged ? "Mi Cuenta" : "Ingresa" }}
            </span>
        </button>
        <!-- Carrito -->
        <button class="nina-navbar__cart" type="button" routerLink="/cart">
            <img src="assets/iconos-nina-png/blanco/cart.png" alt="">
            <span>
                Carrito
            </span>
            <strong>
                {{ itemsCart }}
            </strong>
        </button>
    </div>
    <!-- =========================================================
       3. BARRA DE CATEGORÍAS
       ========================================================= -->
    <div class="nina-navbar__categories">
        <div class="nina-navbar__categories-list">
            <!-- Categorías dinámicas -->
            <!-- Promociones -->
            <button type="button" class="nina-navbar__category" routerLink="/promotions">
                Promociones
            </button>
            <!-- Sucursales -->
            <button type="button" class="nina-navbar__category" routerLink="/branches">
                Sucursales
            </button>
            <!-- Sucursales -->
            <button type="button" class="nina-navbar__category" routerLink="/history" *ngIf="tokenSSLoged">
                Pedidos
            </button>
            <button *ngFor="let linea of navbarLines" type="button" class="nina-navbar__category"
                (click)="goToLinea(linea)">
                {{ toTitleCase(linea.descripcion) }}
            </button>
            <!-- Facturación -->
            <!--
      <a
        class="nina-navbar__category"
        href="URL-FACTURACION"
        target="_blank"
        rel="noopener noreferrer"
      >
        Facturación
      </a>
      -->
        </div>
        <!-- =====================================================
         SELECTOR DE SUCURSAL
         ===================================================== -->

        <!-- <div class="nina-navbar__store-wrapper" [class.is-open]="branchSelectorOpen">
            <button type="button" class="nina-navbar__store" (click)="toggleBranchSelector()">
                <img src="assets/iconos-nina-png/coral/bag.png" alt="">
                <div class="nina-navbar__store-text">
                    <span>
                        Mi tienda
                    </span>
                    <strong>
                        {{ selectedBranchName }}
                    </strong>
                </div>
                <img class="nina-navbar__store-arrow" src="assets/iconos-nina-png/tinta/chevron.png" alt="">
            </button>
            <div class="nina-navbar__branch-dropdown" *ngIf="branchSelectorOpen">
                <button *ngFor="let branch of sucursales" type="button" class="nina-navbar__branch-option"
                    [class.is-selected]="isSelectedBranch(branch)" (click)="selectBranch(branch)">
                    <span class="nina-navbar__branch-icon">
                        <img src="assets/logos-nina/favicon.png" alt="">
                    </span>
                    <span class="nina-navbar__branch-name">
                        {{ formatBranchName(branch.nombre) }}
                    </span>
                </button>
            </div>
        </div> -->
    </div>
</header>
<main class="base-main">
    <router-outlet></router-outlet>
</main>
<app-footer></app-footer>